/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import { Grid } from "@material-ui/core";
//custom libraries

import { Button, RequiredLabel } from "../components";

import { SearchHeader } from "../components/reports/search-header";
import styled from "styled-components";

import { SearchFilterTitle } from "../components/reports/search-filter-title";

import TextField from "@material-ui/core/TextField";
import { FormInputLabel } from "./../components/common/FormInputLabel";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { useClientForm } from "./../hooks/use-client-form";

const schema = yup.object().shape({
  personRegisterDateFrom: yup.string().required("Campo requerido"),
  personRegisterDateTo: yup.string().required("Campo requerido"),
});

export default function CustomerReportForm() {
  const { t } = useTranslation();

  const { submitForm } = useClientForm();

  const {
    register,

    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data: any) => {
    submitForm(data);
  };

  const StyledGridContainer = styled(Grid)`
    margin-bottom: 20px;
  `;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SearchHeader title={t("Report.ReportCustomer")} />
      </Grid>
      <StyledGridContainer>
        <SearchFilterTitle title={t("Report.SearchFilterTitle")} />
      </StyledGridContainer>

      <StyledGridContainer container xs={12} spacing={2}>
        <Grid item xs={12} sm={6} xl={3} md={3}>
          <FormInputLabel text={t("Report.InitialDate")} required />
          <TextField
            size="small"
            variant="outlined"
            type="date"
            fullWidth
            error={errors.personRegisterDateFrom ? true : false}
            helperText={errors.personRegisterDateFrom?.message}
            {...register("personRegisterDateFrom")}
          />
        </Grid>
        <Grid item xs={12} sm={6} xl={3} md={3}>
          <FormInputLabel text={t("Report.EndDate")} required />
          <TextField
            size="small"
            variant="outlined"
            type="date"
            fullWidth
            error={errors.personRegisterDateTo ? true : false}
            helperText={errors.personRegisterDateTo?.message}
            {...register("personRegisterDateTo")}
          />
        </Grid>
      </StyledGridContainer>

      <StyledGridContainer container xs={12}>
        <Grid item xs={12}>
          <RequiredLabel />
        </Grid>
        <Button onClick={handleSubmit(onSubmit)} name="Search">
          {t("OrderManagement.Search")}
        </Button>
      </StyledGridContainer>
    </Grid>
  );
}
